import { render, staticRenderFns } from "./OtherCashRevenueReg.vue?vue&type=template&id=32f68a48&"
import script from "./OtherCashRevenueReg.vue?vue&type=script&lang=js&"
export * from "./OtherCashRevenueReg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports